import React from 'react'
import CommonSectionCategory from '../../../Shared/CommonSectionCategory';
import { categoryModel } from '../../../Model/categoryCons';

const GiftsAndFlowerCategory = () => {
    return (
        <>
            <CommonSectionCategory props={categoryModel.GiftsAndFlowers} />
        </>
    )
}

export default GiftsAndFlowerCategory;